export default __webpack_public_path__ + "images/VN.02bd4ff.png";